import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { LEGAL_NOTICE_LINE_HEIGHT } from "src/components/LegalNotice/styles";

import { PadreText } from "./PadreText";

export const PrivacyPolicySubheader = () => {
  const theme = useTheme();

  return (
    <Stack>
      <Typography
        variant="body2"
        textAlign="center"
        component="p"
        color={theme.palette.text.secondary}
        lineHeight={LEGAL_NOTICE_LINE_HEIGHT}
      >
        This Privacy Policy sets out the rules for the processing and protection
        of personal data obtained from Users when using the <PadreText /> App
        website, available at the Internet address padre.gg, (hereinafter
        referred to as the "Website"), provided by <PadreText /> App,
        (hereinafter referred to as the owner or <PadreText /> App or the
        Administrator).
      </Typography>

      <Typography
        variant="body2"
        textAlign="center"
        component="p"
        color={theme.palette.text.secondary}
        sx={{ mt: 0.75 }}
        lineHeight={LEGAL_NOTICE_LINE_HEIGHT}
      >
        "User" within the meaning of the Privacy Policy means a natural person
        using the Website.
      </Typography>

      <Typography
        variant="body2"
        textAlign="center"
        component="p"
        color={theme.palette.text.secondary}
        sx={{ mt: 0.75 }}
        lineHeight={LEGAL_NOTICE_LINE_HEIGHT}
      >
        Using the Website is tantamount to the User's consent to the terms and
        conditions described in this Privacy Policy.
      </Typography>
    </Stack>
  );
};
